"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfflineReducer = exports.createReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// The root reducer and selector. This wires all the other local selectors/
// reducers together so they operate on the root state object. No game logic
// here, just wiring things together.

//import * as CharsByUser from "./firebase/characters-by-user" // see users/root and auth/root


var _appInfo = require("./firebase/app-info");

var AppInfo = _interopRequireWildcard(_appInfo);

var _auth = require("./firebase/auth");

var Auth = _interopRequireWildcard(_auth);

var _authLoaded = require("./auth-loaded");

var AuthLoaded = _interopRequireWildcard(_authLoaded);

var _beta = require("./firebase/beta");

var Beta = _interopRequireWildcard(_beta);

var _characters = require("./firebase/characters2");

var Chars2 = _interopRequireWildcard(_characters);

var _clientNow = require("./client-now");

var ClientNow = _interopRequireWildcard(_clientNow);

var _entities = require("./entities2");

var Entities = _interopRequireWildcard(_entities);

var _forms = require("./forms");

var Forms = _interopRequireWildcard(_forms);

var _flags = require("./firebase/flags");

var Flags = _interopRequireWildcard(_flags);

var _loading = require("./firebase/loading");

var FirebaseLoading = _interopRequireWildcard(_loading);

var _now = require("./firebase/now");

var Now = _interopRequireWildcard(_now);

var _options = require("./firebase/options");

var Options = _interopRequireWildcard(_options);

var _rankings = require("./firebase/rankings");

var Rankings = _interopRequireWildcard(_rankings);

var _users = require("./firebase/users");

var Users = _interopRequireWildcard(_users);

var _util = require("./util");

var Util = _interopRequireWildcard(_util);

var _decimal = require("../decimal");

var _decimal2 = _interopRequireDefault(_decimal);

var _reactReduxFirebase = require("react-redux-firebase");

var _redux = require("redux");

var _redux2 = require("../redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import {entities as legacyEntities} from "../redux/Reducers"

var createReducer = exports.createReducer = function createReducer(extraReducers) {
  return (0, _redux.combineReducers)(_extends({
    firebase: _reactReduxFirebase.firebaseStateReducer,
    firebaseAuthLoaded: AuthLoaded.reducer,
    // TODO: now that legacy's gone, rename me to `entities` (without the 2)
    entities2: Entities.reducer,
    forms: Forms.reducer,
    clientNow: ClientNow.reducer
  }, extraReducers)
  // dammit flowtype, work with me here
  );
};

var createOfflineReducer = exports.createOfflineReducer = function createOfflineReducer(extraReducers) {
  return createReducer(_extends({}, extraReducers, _redux2.offlineReducers));
};

exports.default = {
  achievementTypes: Entities.AchievementTypes,
  appInfo: AppInfo,
  auth: Auth,
  authLoaded: AuthLoaded,
  beta: Beta,
  buyN: Forms.BuyN,
  chars2: Chars2,
  envConfig: Entities.EnvConfig,
  flags: Flags,
  loading: FirebaseLoading,
  now: Now,
  clientNow: ClientNow,
  options: Options,
  rankings: Rankings,
  unitTypes: Entities.UnitTypes,
  users: Users,
  zoneTypes: Entities.ZoneTypes,

  Util: Util,
  dispatchPromise: Util.dispatchPromise,
  Decimal: _decimal2.default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/index.js
// module id = 22
// module chunks = 0